import React from "react";
import { IoMdClose, IoMdShare } from "react-icons/io";
import {
  FaGift,
  FaHandsHelping,
  FaRegCopy,
  FaUser,
  FaFlag,
  FaQrcode,
  FaYoutube,
  FaVoteYea,
  FaCalendarAlt,
  FaLink
} from "react-icons/fa";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import {
  BiLogOutCircle,
  BiDollarCircle,
  BiChevronLeft,
  BiChevronRight,
  BiChevronDown,
  BiChevronUp,
  BiGitPullRequest,
  BiSupport
} from "react-icons/bi";
import {
  AiOutlineUnorderedList,
  AiFillSetting,
  AiOutlineStar,
  AiFillStar
} from "react-icons/ai";
import {
  MdDashboard,
  MdDelete,
  MdEdit,
  MdOutlineManageAccounts,
  MdAccountBox,
  MdMyLocation,
  MdOutlineMilitaryTech,
  MdKeyboardArrowRight,
  MdOutlinePolicy,
  MdOutlineContactPhone,
  MdOutlinePrivacyTip,
  MdDownloadForOffline
} from "react-icons/md";
import { FiArrowRightCircle, FiSave } from "react-icons/fi";
import { FcTimeline } from "react-icons/fc";
import { GrTransaction } from "react-icons/gr";
import { RiRefundLine, RiUpload2Line } from "react-icons/ri";
import { IoMdMore } from "react-icons/io";
import { FiMoreVertical } from "react-icons/fi";
import { VscServerProcess } from "react-icons/vsc";
import { TbReportAnalytics } from "react-icons/tb";
import { AiOutlineCalculator } from "react-icons/ai";
import { ImUserCheck } from "react-icons/im";
import { TbUserSquare } from "react-icons/tb";
import { MdOutlineReport } from "react-icons/md";
import { LuWallet } from "react-icons/lu";
import {
  IoInformationCircleOutline,
  IoNotificationsSharp,
  IoScan
} from "react-icons/io5";
import { FaArrowLeft } from "react-icons/fa6";
import { BiSolidUserPin } from "react-icons/bi";
import { IoMdRefresh } from "react-icons/io";
import { BiPurchaseTag } from "react-icons/bi";
import { IoReorderThree } from "react-icons/io5";
import { TbAffiliate } from "react-icons/tb";
import { MdMapsHomeWork } from "react-icons/md";
import {
  BsFiletypeJson,
  BsGearWideConnected,
  BsInfoSquare
} from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { RiFileExcel2Fill } from "react-icons/ri";
import { FaStar } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";
import { TbLogout2 } from "react-icons/tb";
import { IoPieChartOutline } from "react-icons/io5";
import { IoIosAdd } from "react-icons/io";
import { BiSolidBank } from "react-icons/bi";
import { IoIosAlert } from "react-icons/io";
import { BiAdjust } from "react-icons/bi";
import { IoIosArrowRoundBack, IoMdArrowDropdown } from "react-icons/io";
import { MdRefresh } from "react-icons/md";
import { FaTwitter, FaInstagram, FaGithub, FaWhatsapp } from "react-icons/fa";
import { IoLogOutOutline } from "react-icons/io5";
import { BiLogIn } from "react-icons/bi";
import { GoArrowRight, GoDotFill } from "react-icons/go";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { BsLightningChargeFill } from "react-icons/bs";
import { MdKeyboardArrowUp } from "react-icons/md";
import { FaCheck, FaRegEye, FaRegEyeSlash, FaRegStar } from "react-icons/fa";
import { FaCirclePlay } from "react-icons/fa6";
import { GiGamepadCross } from "react-icons/gi";
import {
  MdOutlineSportsCricket,
  MdOutlineSportsTennis,
  MdOutlineGamepad,
  MdOutlineSportsBasketball
} from "react-icons/md";
import { IoFootballOutline } from "react-icons/io5";
import { PiTennisBallLight } from "react-icons/pi";
import { IoMdSettings } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { MdOutlineAccessTime } from "react-icons/md";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { LiaHorseHeadSolid } from "react-icons/lia";
import { TbDeviceGamepad2 } from "react-icons/tb";
import { CgFileDocument } from "react-icons/cg";
import { FaCheckToSlot } from "react-icons/fa6";
import { BsMagic } from "react-icons/bs";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaPlay } from "react-icons/fa";
import { MdLiveTv } from "react-icons/md";
import { BsFire } from "react-icons/bs";
import { RiFileListLine } from "react-icons/ri";
import { LuClock3 } from "react-icons/lu";
import { PiLadderSimple } from "react-icons/pi";
import { CiLock } from "react-icons/ci";
import { AiOutlineHome } from "react-icons/ai";
import { BsBank2 } from "react-icons/bs";
import { FaMoneyBill, FaLinkedin, FaTelegramPlane } from "react-icons/fa";
import { RiBook2Fill } from "react-icons/ri";
import { RiPagesFill } from "react-icons/ri";
import { FaList } from "react-icons/fa6";
import { FaArrowRightLong, FaArrowLeftLong } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
import { FaFileDownload } from "react-icons/fa";
import { FaRegCircle } from "react-icons/fa";
import { FaRegSquare } from "react-icons/fa";
import { MdAdsClick } from "react-icons/md";
import { FaRegFilePdf } from "react-icons/fa6";
import { FaRedditAlien } from "react-icons/fa";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { HiMiniArrowTopRightOnSquare } from "react-icons/hi2";
import { HiBadgeCheck, HiChevronRight } from "react-icons/hi";
import { HiOutlineExclamation } from "react-icons/hi";

export const reactIcons = {
  alert: <IoIosAlert />,
  save: <FiSave />,
  logout: <BiLogOutCircle />,
  dollar: <BiDollarCircle />,
  list: <AiOutlineUnorderedList />,
  arrowleft: <BiChevronLeft />,
  arrowright: <BiChevronRight />,
  arrowDown: <BiChevronDown />,
  arrowUp: <BiChevronUp />,
  dashboard: <MdDashboard />,
  setting: <AiFillSetting />,
  edit: <MdEdit />,
  delete: <MdDelete />,
  manage: <MdOutlineManageAccounts />,
  gift: <FaGift />,
  star: <AiOutlineStar />,
  fillstar: <AiFillStar />,
  eyeVisible: <AiFillEye />,
  eyeInVisible: <AiFillEyeInvisible />,
  close: <IoMdClose />,
  copy: <FaRegCopy />,
  handShake: <FaHandsHelping />,
  timeline: <FcTimeline />,
  transactions: <GrTransaction />,
  request: <BiGitPullRequest />,
  flag: <FaFlag />,
  qrCode: <FaQrcode />,
  account: <MdAccountBox />,
  upload: <RiUpload2Line />,
  more: <FiMoreVertical />,
  moreItems: <IoMdMore />,
  location: <MdMyLocation />,
  process: <VscServerProcess />,
  TbReportAnalytics: <TbReportAnalytics />,
  calculater: <AiOutlineCalculator />,
  userCheck: <ImUserCheck />,
  kyc: <TbUserSquare />,
  report: <MdOutlineReport />,
  wallet: <LuWallet />,
  info: <IoInformationCircleOutline />,
  leftArrow: <FaArrowLeft />,
  login: <BiSolidUserPin />,
  gear: <BsGearWideConnected />,
  refresh: <IoMdRefresh />,
  check: <FaCheck />,
  purchase: <BiPurchaseTag />,
  toggle: <IoReorderThree />,
  affiliate: <TbAffiliate />,
  franchise: <MdMapsHomeWork />,
  excell: <RiFileExcel2Fill />,
  starFill: <FaStar />,
  infoFill: <FaInfoCircle />,
  disconnect: <TbLogout2 />,
  fraction: <IoPieChartOutline />,
  add: <IoIosAdd />,
  bank: <BiSolidBank />,
  reward: <MdOutlineMilitaryTech />,
  notification: <IoNotificationsSharp />,
  support: <BiSupport />,
  ioScan: <IoScan />,
  linkedIn: <FaLinkedin />,
  telegram: <FaTelegramPlane />,
  whatsapp: <FaWhatsapp />,
  ads_click: <MdAdsClick />,
  square: <FaRegSquare />,
  circle: <FaRegCircle />,
  plus: <FaPlus />,
  dropArrow: <IoMdArrowDropdown />,
  longRight: <FaArrowRightLong />,
  fb: <FaFacebookF />,
  git: <FaGithub />,
  instagram: <FaInstagram />,
  longLeft: <FaArrowLeftLong />,
  dummy: <BiAdjust />,
  refresh1: <MdRefresh />,
  twitter: <FaTwitter />,
  list1: <FaList />,
  withdraw: <RiPagesFill />,
  book: <RiBook2Fill />,
  money: <FaMoneyBill />,
  bigLeft: <FaArrowLeft />,
  bank: <BsBank2 />,
  user: <FaUser />,
  home: <AiOutlineHome />,
  lock: <CiLock />,
  ladder: <PiLadderSimple />,
  fireClock: <LuClock3 />,
  file: <RiFileListLine />,
  fire: <BsFire />,
  tv: <MdLiveTv />,
  play2: <FaPlay />,
  hamburger: <GiHamburgerMenu />,
  logout: <IoLogOutOutline />,
  login: <BiLogIn />,
  dot: <GoDotFill />,
  downArrow: <MdOutlineKeyboardArrowDown />,
  upArrow: <MdKeyboardArrowUp />,
  lightning: <BsLightningChargeFill />,
  star: <FaRegStar />,
  play: <FaCirclePlay />,
  casino: <GiGamepadCross />,
  cricket: <MdOutlineSportsCricket />,
  football: <IoFootballOutline />,
  tennis: <PiTennisBallLight />,
  search: <FiSearch />,
  setting: <IoMdSettings />,
  close: <IoClose />,
  watch: <MdOutlineAccessTime />,
  arrowleft: <BsChevronLeft />,
  arrowright: <BsChevronRight />,
  checkMark: <FaCheck />,
  eye: <FaRegEye />,
  eyeSlash: <FaRegEyeSlash />,
  tenis: <MdOutlineSportsTennis />,
  vgame: <MdOutlineGamepad />,
  basketball: <MdOutlineSportsBasketball />,
  horse: <LiaHorseHeadSolid />,
  egame: <TbDeviceGamepad2 />,
  politics: <CgFileDocument />,
  slot: <FaCheckToSlot />,
  magic: <BsMagic />,
  pdf: <FaRegFilePdf />,
  back: <IoIosArrowRoundBack />,
  reddit: <FaRedditAlien />,
  leftArrow: <MdKeyboardArrowLeft />,
  rightArrow: <MdKeyboardArrowRight />,
  download: <FaFileDownload />,
  about: <BsInfoSquare />,
  policy: <MdOutlinePolicy />,
  contact: <MdOutlineContactPhone />,
  privacy: <MdOutlinePrivacyTip />,
  refund: <RiRefundLine />,
  download: <MdDownloadForOffline />,
  youtube: <FaYoutube />,
  walletArrow: <GoArrowRight />,
  goArrow: <HiMiniArrowTopRightOnSquare />,
  vote: <FaVoteYea />,
  rightarrow: <FiArrowRightCircle />,
  rgtArrow: <HiChevronRight />,
  share: <IoMdShare />,
  badgeCheck: <HiBadgeCheck />,
  exclamation: <HiOutlineExclamation />,
  jsonfile: <BsFiletypeJson />,
  calendar: <FaCalendarAlt />,
  link: <FaLink />
};
